import { createClass as _createClass } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _class, _class2, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "198fdvgqTtF+YdqsoD5gLz9", "UITipsCtrl", undefined);

import { _decorator, Component, UIOpacity, instantiate, Label, tween, v3 } from 'cc';
import { E_ResPath } from '../EnumBase';
import { App } from './App';
var ccclass = _decorator.ccclass;
export var UITipsCtrl = (_dec = ccclass('UITipsCtrl'), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inheritsLoose(UITipsCtrl, _Component);

  function UITipsCtrl() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "_tips", []);

    _defineProperty(_assertThisInitialized(_this), "_t", 0);

    return _this;
  }

  var _proto = UITipsCtrl.prototype;

  _proto.showTip = function showTip(msg) {
    this._tips.push(msg);
  };

  _proto.actMsg = function actMsg() {
    var _this2 = this;

    App.ResMgr.getPfb(E_ResPath.Pfb_Root + "adMsg", this, function (prefab) {
      var curMsg = _this2._tips.shift();

      var n_cur = instantiate(prefab);
      n_cur.parent = App.GameCtrl.n_msgRoot;
      n_cur.setPosition(0, 0, 0);
      n_cur.getComponent(Label).string = curMsg;
      var uiOpacity = n_cur.getComponent(UIOpacity);
      tween(n_cur).by(1.5, {
        position: v3(0, 200, 0)
      }).call(function () {
        n_cur.destroy();
      }).start();
      tween(uiOpacity).delay(1).to(0.5, {
        opacity: 0
      }).start();
    }, true);
  };

  _proto.update = function update(dt) {
    if (this._t > 0) {
      this._t -= dt;
    } else if (this._tips.length > 0) {
      this._t = 0.1;
      this.actMsg();
    }
  };

  _createClass(UITipsCtrl, null, [{
    key: "I",
    get: function get() {
      if (!UITipsCtrl._I) {
        UITipsCtrl._I = new UITipsCtrl();
      }

      return UITipsCtrl._I;
    } //飘字

  }]);

  return UITipsCtrl;
}(Component), _defineProperty(_class2, "_I", null), _temp)) || _class);
/**
 * [1] Class member could be defined like this.
 * [2] Use `property` decorator if your want the member to be serializable.
 * [3] Your initialization goes here.
 * [4] Your update function goes here.
 *
 * Learn more about scripting: https://docs.cocos.com/creator/3.0/manual/en/scripting/
 * Learn more about CCClass: https://docs.cocos.com/creator/3.0/manual/en/scripting/ccclass.html
 * Learn more about life-cycle callbacks: https://docs.cocos.com/creator/3.0/manual/en/scripting/life-cycle-callbacks.html
 */

_cclegacy._RF.pop();